<template>
  <div>
    <div class="row f-row mt-1 results-header">
      <div class="col col-12 analytics_results text-left">
        SELECTED DATE: / AVERAGE FROM:
      </div>
    </div>
    <div class="row f-row mt-2 results-header">
      <div class="col col-12 analytics_results">
        <table class="table-borderless table-sm analytics_table">
          <tbody>
            <tr class="text-left">
              <th style="width:10%">ASSET</th>
              <th style="width:15%">DATE</th>
              <th style="width:10%">PRICE (USD / mt)</th>
              <th style="width:10%">FREIGHT</th>
              <th style="width:10%">TARIFF (%)</th>
              <th style="width:10%">USD/COP</th>
              <th style="width:15%">PRICE (COP / mt)</th>
              <th style="width:10%">COMPENSATION</th>
              <th style="width:15%">NET</th>
            </tr>
            <tr>
              <th
                class="text-left"
                style="border-right: 1px solid var(--lightbackground); font-size: 1.2rem;"
              >
                FEP
              </th>
              <th rowspan="2">
                <div
                  id="fep_date"
                  class="inh ml-2"
                  style="color: var(--textactive); font-size: 1rem;"
                >
                  ...
                </div>
              </th>
              <td class="table-center-borders">
                <div id="fep_bmd" class="inh">0</div>
              </td>
              <td>
                <InputNumber
                  :tableFormat="true"
                  :value="newFreight"
                  @input="val => onUserFreightChange(val)"
                />
              </td>
              <td class="table-center-borders">
                <InputNumber
                  :tableFormat="true"
                  :value="newTariff"
                  @input="val => onUserTariffChange(val)"
                />
              </td>
              <td>
                <div id="fep_usdcop" class="inh">0</div>
              </td>
              <td
                style="font-size: 1.2rem; color: var(--symmetry-h)!important;"
                class="table-center-borders"
              >
                <div id="fep_cop" class="inh">0</div>
              </td>
              <td>
                <InputNumber
                  :tableFormat="true"
                  :value="newComp"
                  @input="val => onUserCompChange(val)"
                />
              </td>
              <td
                style="border-left: 1px solid var(--lightbackground); font-size: 1.2rem;"
              >
                <div id="fep_cop_comp" class="inh">0</div>
              </td>
            </tr>
            <tr>
              <th
                class="text-left"
                style="width:10%; border-right: 1px solid var(--lightbackground); font-size: 1.2rem;"
              >
                ROTT
              </th>
              <td style="width:15%" class="table-center-borders">
                <div id="impo_expo_bmd" class="inh">0</div>
              </td>
              <td style="width:15%">
                <InputNumber
                  :tableFormat="true"
                  :value="newFreightRott"
                  @input="val => onUserFreightChangeRott(val)"
                />
              </td>
              <td style="width:15%" class="table-center-borders">
                <InputNumber
                  :tableFormat="true"
                  :value="newTariffRott"
                  @input="val => onUserTariffChangeRott(val)"
                />
              </td>
              <td style="width:15%">
                <div id="impo_expo_usdcop" class="inh">0</div>
              </td>
              <td
                style="width:15%; font-size: 1.2rem; color: var(--hedge-h)!important;"
                class="table-center-borders"
              >
                <div id="impo_expo_cop" class="inh">0</div>
              </td>
              <td style="width:15%">
                <InputNumber
                  :tableFormat="true"
                  :value="newCompRott"
                  @input="val => onUserCompChangeRott(val)"
                />
              </td>
              <td
                style="font-size: 1.2rem; border-left: 1px solid var(--lightbackground);"
              >
                <div id="impo_expo_cop_comp" class="inh">0</div>
              </td>
            </tr>
            <tr style="border-top: 1px solid var(--lightbackground-alpha3)">
              <th
                class="text-left"
                style="border-right: 1px solid var(--lightbackground); font-size: 1.2rem;"
              >
                FEP
              </th>
              <th rowspan="2">
                <div
                  class="inh ml-1"
                  style="color: var(--textactive); font-size: 1rem;"
                >
                  {{ inDate | formatDate }}
                </div>
                to
                <div
                  class="inh ml-1"
                  style="color: var(--textactive); font-size: 1rem;"
                >
                  {{ endDate | formatDate }}
                </div>
              </th>
              <td class="table-center-borders">
                {{ aveDataFEP.bmd | priceFormat }}
              </td>
              <td>
                <InputNumber
                  :tableFormat="true"
                  :value="newFreight"
                  @input="val => onUserFreightChange(val)"
                />
              </td>
              <td class="table-center-borders">
                <InputNumber
                  :tableFormat="true"
                  :value="newTariff"
                  @input="val => onUserTariffChange(val)"
                />
              </td>
              <td>
                {{ aveDataFEP.usdcop | priceFormat }}
              </td>
              <td
                style="font-size: 1.2rem; color: var(--symmetry-h)!important;"
                class="table-center-borders"
              >
                {{ aveDataFEP.close | priceFormat }}
              </td>
              <td>
                <InputNumber
                  :tableFormat="true"
                  :value="newComp"
                  @input="val => onUserCompChange(val)"
                />
              </td>
              <td
                style="border-left: 1px solid var(--lightbackground); font-size: 1.2rem;"
              >
                {{ (aveDataFEP.close + comp) | priceFormat }}
              </td>
            </tr>
            <tr>
              <th
                class="text-left"
                style="border-right: 1px solid var(--lightbackground); font-size: 1.2rem;"
              >
                ROTT
              </th>
              <td class="table-center-borders">
                {{ aveDataRott.bmd | priceFormat }}
              </td>
              <td style="width:15%">
                <InputNumber
                  :tableFormat="true"
                  :value="newFreightRott"
                  @input="val => onUserFreightChangeRott(val)"
                />
              </td>
              <td style="width:15%" class="table-center-borders">
                <InputNumber
                  :tableFormat="true"
                  :value="newTariffRott"
                  @input="val => onUserTariffChangeRott(val)"
                />
              </td>
              <td>
                {{ aveDataRott.usdcop | priceFormat }}
              </td>
              <td
                class="table-center-borders"
                style="font-size: 1.2rem; color: var(--hedge-h)!important;"
              >
                {{ aveDataRott.close | priceFormat }}
              </td>
              <td style="width:15%">
                <InputNumber
                  :tableFormat="true"
                  :value="newCompRott"
                  @input="val => onUserCompChangeRott(val)"
                />
              </td>
              <td
                style="border-left: 1px solid var(--lightbackground); font-size: 1.2rem;"
              >
                {{ (aveDataRott.close + newCompRott) | priceFormat }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "d3";
import moment from "moment";
import InputNumber from "@/components/InputNumber";

export default {
  name: "CPOTableComparison",
  props: {
    freight: { required: true },
    tariff: { required: true },
    aveDataFEP: { required: true },
    comp: { required: true },
    freightRott: { required: true },
    tariffRott: { required: true },
    aveDataRott: { required: true },
    compRott: { required: true },
    inDate: { required: true },
    endDate: { required: true }
  },
  components: {
    InputNumber
  },
  data() {
    return {
      newFreight: 0,
      newFreightRott: 0,
      newTariff: 0,
      newTariffRott: 0,
      newComp: 0,
      newCompRott: 0
    };
  },
  filters: {
    priceFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",.6r")(val);
    },
    formatDate: function(value) {
      if (value) {
        return moment(String(value))
          .format("MMM YY")
          .toUpperCase();
      }
    }
  },
  mounted() {
    this.newFreight = this.freight;
    this.newTariff = this.tariff;
    this.newFreightRott = this.freightRott;
    this.newTariffRott = this.tariffRott;
    this.newComp = this.comp;
    this.newCompRott = this.compRott;
  },
  watch: {
    freight() {
      this.newFreight = this.freight;
    },
    tariff() {
      this.newTariff = this.tariff;
    },
    freightRott() {
      this.newFreightRott = this.freightRott;
    },
    tariffRott() {
      this.newTariffRott = this.tariffRott;
    },
    comp() {
      this.newComp = this.comp;
    },
    compRott() {
      this.newCompRott = this.compRott;
    }
  },
  methods: {
    // === user interactions ===
    onUserFreightChange(val) {
      this.$emit("eventOnUserFreightChange", val);
    },
    onUserTariffChange(val) {
      this.$emit("eventOnUserTariffChange", val);
    },
    onUserFreightChangeRott(val) {
      this.$emit("eventOnUserFreightChangeRott", val);
    },
    onUserTariffChangeRott(val) {
      this.$emit("eventOnUserTariffChangeRott", val);
    },
    onUserCompChange(val) {
      this.$emit("eventOnUserCompChange", val);
    },
    onUserCompChangeRott(val) {
      this.$emit("eventOnUserCompChangeRott", val);
    }
  }
};
</script>

<style scoped></style>
